import he from "he";

// const RAZORPAYKEY = "rzp_test_zlnJL2IPz5C8L4"; // TEST
const RAZORPAYKEY = "rzp_live_oJwJ4EBDWMmOmf"; // Live

const regex = /<u>(.*?)<\/u>/;
export const hasImage = (text) => {
  if (
    text?.includes("pg/ckeditor") ||
    text?.includes("data:image") ||
    text?.includes("s3.ap-south-1.amazonaws.com") ||
    text?.includes("<br />") ||
    text?.includes("cellpadding") ||
    text?.includes("<math xmlns=") ||
    regex.test(text)
  ) {
    return true;
  } else {
    return false;
  }
};

export const isTrueFalse = (item) => {
  if (item?.qtype === "3") {
    if (item?.answer === "1") {
      return "True";
    } else if (item?.answer === "0") {
      return "False";
    } else {
      return item?.finalAnswer;
    }
    // return true;
  } else {
    return item?.rightAnswer
      ? item?.rightAnswer
      : item?.finalAnswer
        ? item?.finalAnswer
        : item?.answer;
  }
};

export const removeFirstAndLastThreeChars = (sentence) => {
  try {
    const newSentence = he?.decode(
      sentence?.replace(/<\/?p>/g, "")
    );
    if (sentence?.substring(0, 3) === "<p>" && sentence?.slice(-4) === "</p>") {
      return sentence?.substring(3, sentence?.length - 4);
    } else {
      return newSentence;
    }

  } catch (error) {

    return sentence
  }
};

export const removeFirstAndLastThreeCharsparagraph = (sentence) => {
  try {

    let newSentence;
    if (sentence?.includes("math ")) {

      newSentence = he?.decode(
        sentence?.replace(/<\/?p>/g, "")
        // .replace(/\n/g, "<br />")
      );

    } else {

      newSentence = he?.decode(
        sentence?.replace(/<\/?p>/g, "")
          .replace(/\n/g, "<br />")
      );
    }

    if (sentence?.substring(0, 3) === "<p>" && sentence?.slice(-4) === "</p>") {
      return sentence?.substring(3, sentence?.length - 4);
    } else {
      return newSentence;
    }

  } catch (error) {

    return sentence
  }
};

export function replaceMathTagWithAltText(html) {
  // const regex = /<math xmlns=.*?alttext="([^"]+)".*?<\/math>/g;

  // return html.replace(regex, '$1');
  // eslint-disable-next-line no-unused-vars
  const regex = /<math.*?>(.*?)<\/math>/g;

  // const regex = /<math.*?<\/math>/g;

  if (html?.includes("<math xmlns=")) {
    return html?.replace(/<\/?[^>]+>/g, "")?.trim();
  } else {
    return html;
  }
  // return html.replace(/<[^>]+>/g, '');
  // const mathtext = html.replace(regex, "")

  // return mathtext.replace(regex, '');
}

export const handlePayment = (data, description) => {
  return new Promise((resolve, reject) => {
    try {
      var options = {
        description: description || "",
        image: "https://patramkids.s3.ap-south-1.amazonaws.com/logo.png",
        currency: data?.currency,
        key: RAZORPAYKEY, // Your api key
        amount: data?.amount,
        name: "Youth",
        order_id: data?.razorpayOrderId,
        handler: async function (response) {
          resolve(response);

        },
        ...(data.order && {
          prefill: {
            email: data.order.email,
            contact: data.order.mobileNo,
            name: data.order.fullName,
          },
        }),
        modal: {
          ondismiss: function () {
            reject();
          },
        },
        theme: {
          color: "#138FC2",
          hide_topbar: false,
        },
        allow_international: true,
      };

      var rzp1 = new window.Razorpay(options);
      rzp1.open();
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};
